import apiUrl from "./config/config";
import axios from "axios";

class processTemplateApi {

  //Get a process 
  static async getProcess(id)
  {

    try
    {

      const response = await axios(apiUrl + `process/${id}`);

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Get all processes
  static async getProcesses(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "process", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Update a process
  static async updateProcess(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "process", params);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

  //Delete a process
  static async deleteProcess(id)
  {

    try
    {

      const response = await axios.delete(apiUrl + `process/${id}`);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }


  //Get process with steps
  static async getProcessesStep(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "process/step", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //STEP
  //Update a processstep
  static async updateProcessStep(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "process/step", params);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }


  //Get all process template
  static async getProcessTemplates(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "process/template", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Get a process template
  static async getProcessTemplate(id)
  {

    try
    {

      const response = await axios(apiUrl + `process/template/${id}`);

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Update a process template
  static async updateProcessTemplate(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "process/template", params);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

  //Delete a process template
  static async deleteProcessTemplate(id)
  {

    try
    {

      const response = await axios.delete(apiUrl + `process/template/${id}`);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }


  //Get process step templates
  static async getProcessesStepTemplates(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "process/step/template", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Get a process with all it's step
  static async getProcessWithSteps(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "process/withsteps", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }



  //Publish

  //Get a process 
  static async getPublishProcess(id)
  {

    try
    {

      const response = await axios(apiUrl + `process/publish/${id}`);

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Get all processes
  static async getPublishProcesses(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "process/publish", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Get a published process with all it's step
  static async getPublishProcessWithSteps(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "process/publish/withsteps", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Publish a process
  static async publishProcess(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "process/publish", params);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

  //Delete a process
  static async deletePublishProcess(id)
  {

    try
    {

      const response = await axios.delete(apiUrl + `process/publish/${id}`);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }



//FILES

  //Get a processFile 
  static async getProcessFile(id)
  {

    try
    {

      const response = await axios(apiUrl + `process/file/${id}`);

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Get all processFiles
  static async getProcessFiles(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "process/file", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }


  //Update a processFile
  static async updateProcessFile(params)
  {

    try
    {


      const response = await axios.post(apiUrl + "process/file", params, {
        'Content-Type': 'multipart/form-data',
        headers: { Pragma: 'no-cache' }
      });

      // const response = await axios.post(apiUrl + "process/file", params);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

  //Delete a processFile
  static async deleteProcessFile(id)
  {

    try
    {

      const response = await axios.delete(apiUrl + `process/file/${id}`);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

  //Get a processFile 
  static async downloadProcessFile(id)
  {

    try
    {

      const response = await axios(apiUrl + `process/file/download/${id}`, {
        responseType: 'arraybuffer'
      });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }



}




export default processTemplateApi;
